import React from "react";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "./AuthContext";
import { isAdmin } from "./roles";
import LoginScreen from "./LoginScreen";
import "./auth.css";

export const AdminGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, accessToken, logout } = useAuthContext();
  const { t } = useTranslation();

  // Restoring a session from the refresh-token cookie.
  if (isLoading) {
    return (
      <div className="auth-fullscreen">
        <div className="auth-spinner" />
      </div>
    );
  }

  // No session yet → email + code login.
  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  // Signed in — gate on the FusionAuth `admin` role in the JWT. UX only: the real
  // boundary is `[Authorize(Roles = ["admin"])]` on each admin GraphQL query.
  if (!isAdmin(accessToken)) {
    return (
      <div className="auth-fullscreen">
        <div className="auth-card">
          <LogoMark />
          <h1 className="auth-title">{t("auth.denied.title")}</h1>
          <p className="auth-subtitle">{t("auth.denied.subtitle")}</p>
          <button className="auth-btn auth-btn--ghost" onClick={logout}>
            {t("auth.denied.signOut")}
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

const LogoMark: React.FC = () => (
  <div className="auth-logo">
    <img src="/topbar_logo.svg" alt="Lyra" />
  </div>
);
